import React, { useEffect, useState, useRef, useMemo } from "react";
import Icon, { CloseOutlined } from "@ant-design/icons";
import {
  Select,
  Collapse,
  Tabs,
  Button,
  Tooltip,
  Input,
  Space,
  Badge,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { setWidgetMakerGraphData } from "../../../redux/actions/WidgetMaker/WidgetAPI";
import { useDispatch, useSelector } from "react-redux";
import {
  setCardBenchmarkLine,
  setCardSeriesAggregation,
  setChartEditField,
  setWidgetCardLimit,
  setWidgetCardPosition,
} from "../../../redux/actions/WidgetMaker/GraphConfig";
import { Draggable, Droppable } from "react-beautiful-dnd";
import {
  setY_attribute,
  setX_attribute,
} from "../../../redux/actions/WidgetMaker/GraphConfig";
import uuid from "react-uuid";
import EditFieldModal from "../EditFieldModal/EditFieldModal";
import {
  getCustomizedDate,
  updateChartSettingsInGraphObjectBasedOnSelection,
} from "../../../redux/constants";
import moment from "moment";
import {
  setFilterActiveKey,
  setradioArray,
  setradioChecked,
} from "../../../redux/actions/Filter";
import { setOptionHighChart } from "../../../redux/actions/HighChart";
import {
  setChartAttributesFieldConfig,
  setWidgetMakerApiCallFlag,
} from "../../../redux/actions/WidgetMaker/WidgetMaker";
import SettingsLogo from "../../../assets/Settings_Logo.svg";
import SettingLogoHover from "../../../assets/setting_icon_blue.svg";
import Drag_Icon from "../../../assets/Template/Drag_Icon.svg";
import { supportedBenchmarkTraceChartTypes } from "../../../redux/constants/enums";
const CloseIcon = (props) => <Icon component={CloseOutlined} {...props} />;

const { Panel } = Collapse;
const { Option } = Select;

const CardSetting = () => {
  const dispatch = useDispatch();
  const [fontColor, setFontColor] = useState("#3B5175");
  const [BackgroundColor, setBackgroundColor] = useState("#f2f2f2");
  const [cardsList, setCardsList] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);

  const [cardCount, setCardCount] = useState(0);
  const [addNewCards, setAddNewCards] = useState(false);
  const [widgetMakerClearFilter, setWidgetMakerClearFilter] = useState(false);
  const [isFilterApplied, setisFilterApplied] = useState(false);
  const [filterSearch, setfilterSearch] = useState("");
  const [editName, setEditName] = useState();
  const [editAggregation, setAggregation] = useState("count");
  const [editPanelPosition, setEditPanelPosition] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false); // New state for modal
  const [activeCardField, setActiveCardField] = useState(null); // Track active field {cardId, fieldType}
  const [isAddingNewCard, setIsAddingNewCard] = useState(false); // Track when adding new card
  const [hasInitialized, setHasInitialized] = useState(false); // Track if we've initialized default field
  const initializationAttempted = useRef(false); // Track initialization attempts
  const chartLoader = useSelector((state) => state?.WidgetAPI?.chart_loader);
  const windowHeight = window?.innerHeight - editPanelPosition;

  const chartCardData = useSelector(
    (state) => state?.WidgetAPI?.chart_card_data
  );
  const axisPanelAtt = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const radioArray = useSelector((state) => state.Filter.radioArray);
  const radioChecked = useSelector((state) => state.Filter.radioChecked);

  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const isshowSideBar = useSelector((state) => state.WidgetMaker.isshowSideBar);

  const chartAttributesFieldConfig = useSelector(
    (state) => state?.WidgetMaker?.chart_attributes_field_config
  );

  // Use a ref to always have access to the latest field config
  const chartAttributesFieldConfigRef = useRef(chartAttributesFieldConfig);
  useEffect(() => {
    chartAttributesFieldConfigRef.current = chartAttributesFieldConfig;
  }, [chartAttributesFieldConfig]);

  let chart_type = axisPanelAtt.chart_type;
  const darkTheme = document.body.getAttribute("data-theme");

  // Check if the last card has a y-series attribute selected
  const canAddNewCard = useMemo(() => {
    const cardSettings = axisPanelAtt?.card_settings;
    if (!cardSettings || cardSettings.length === 0) {
      return true; // Allow adding first card
    }

    const lastCard = cardSettings[cardSettings.length - 1];
    return lastCard?.y_series?.attribute ? true : false;
  }, [axisPanelAtt?.card_settings]);

  // No modal needed - direct attribute list update

  // Monitor when to clear active field - when exiting card settings mode
  useEffect(() => {
    // Clear activeCardField when exiting card settings mode
    if (!chartAttributesFieldConfig?.open_chart_setting_flag) {
      setActiveCardField(null);
    }
  }, [chartAttributesFieldConfig?.open_chart_setting_flag]);

  // Store the initial field configurations before entering card settings
  const originalFieldConfigRef = useRef(null);

  useEffect(() => {
    // Capture the original field configuration when NOT in card settings mode
    if (
      chartAttributesFieldConfig?.data &&
      !chartAttributesFieldConfig?.open_chart_setting_flag &&
      chartAttributesFieldConfig?.data?.length > 0
    ) {
      // Store a deep copy to prevent reference issues
      originalFieldConfigRef.current = JSON.parse(
        JSON.stringify(chartAttributesFieldConfig.data)
      );
    }
  }, [chartAttributesFieldConfig]);

  // Reset initialization and field config when chart type changes
  useEffect(() => {
    setHasInitialized(false);
    initializationAttempted.current = false;
    // Clear the original config to force refresh
    originalFieldConfigRef.current = null;
  }, [axisPanelAtt?.chart_type]);

  useEffect(() => {
    if (axisPanelAtt?.card_settings?.length > 0) {
      let openCard = false;
      let cnt = 0;
      axisPanelAtt?.card_settings?.map((item, itemIndex) => {
        if (!item?.x_axis && !item?.y_series) {
          openCard = true;
        }

        if (itemIndex === axisPanelAtt?.card_settings?.length - 1) {
          if (item?.response?.[0]?.data) {
            item?.response?.map((res) => {
              res?.data?.map((data, dataIndex) => {
                cnt = cnt + 1;
              });
            });
          } else {
            item?.response?.map((data, dataIndex) => {
              cnt = cnt + 1;
            });
          }
        }
      });
      setCardCount(cnt);
      // Don't immediately disable add button when there's an empty card
      // This allows the card to be properly initialized
      if (openCard && activeCardField === null) {
        setAddNewCards(openCard);
      } else {
        setAddNewCards(false);
      }
    } else {
      setAddNewCards(false);
    }
  }, [axisPanelAtt?.card_settings?.length, activeCardField]); // Reduced dependencies

  // Separate effect for initial field highlighting
  useEffect(() => {
    // Check if we should initialize the default field selection
    if (
      !initializationAttempted.current &&
      axisPanelAtt?.card_settings?.length > 0 &&
      axisPanelAtt?.card_settings?.[0]?.card_id &&
      !activeCardField
    ) {
      // Only if no field is currently active

      initializationAttempted.current = true;

      // Wait a bit to ensure all field configs are loaded
      const initializeTimer = setTimeout(() => {
        // Initialize default Group by field selection
        if (axisPanelAtt?.card_settings?.[0]?.card_id) {
          handleCardFieldClick(
            axisPanelAtt?.card_settings?.[0]?.card_id,
            "x_axis"
          );
        }
      }, 800);

      return () => clearTimeout(initializeTimer);
    }
  }, [axisPanelAtt?.card_settings, activeCardField]);

  const addNewCard = (yAxis) => {
    dispatch(setWidgetMakerApiCallFlag(true));
    dispatch(
      setY_attribute({
        ...axisPanelAtt,
        [`card_settings`]: [
          ...axisPanelAtt?.card_settings,
          {
            card_id: uuid(),
            card_name: axisPanelAtt?.card_settings?.length + 1,
            card_value: null,
            x_axis: null,
            y_series: null,
            response: null,
          },
        ],
        [`edit_fields`]: {
          ...axisPanelAtt[`edit_fields`],
          series: `kpi_card_${axisPanelAtt?.card_settings?.length + 1}`,
        },
      })
    );

    dispatch(
      setradioChecked({
        ...radioChecked,
        [`kpi_card_${axisPanelAtt?.card_settings?.length + 1}`]: {
          data: {},
        },
      })
    );
    dispatch(
      setradioArray({
        ...radioArray,
        [`kpi_card_${axisPanelAtt?.card_settings?.length + 1}`]: {
          data: [],
        },
      })
    );
  };

  const removeNewCard = (data, index) => {
    if (!axisPanelAtt?.card_settings[index - 1]?.y_series) {
      dispatch(setWidgetMakerApiCallFlag(true));
    }
    let lastResponseIfBenchMarkCard = null;
    let updateCards = axisPanelAtt?.card_settings;
    if (
      updateCards?.length === 1 &&
      !updateCards?.[index - 1]?.y_series &&
      !updateCards?.[index - 1]?.x_axis &&
      updateCards?.[index - 1]?.response
    ) {
      lastResponseIfBenchMarkCard = updateCards?.[index - 1]?.response;
    }
    const filterData = updateCards?.filter((d) => d?.card_id !== data?.card_id);

    let updateRadioArray = radioArray;
    delete updateRadioArray[`kpi_card_${data?.card_id}`];
    let updateRadioChecked = radioChecked;
    delete updateRadioChecked[`kpi_card_${data?.card_id}`];

    let combineRadioCheckedArray = Object?.entries(updateRadioChecked)?.filter(
      (el) => el[0]?.split("_")[0] !== "kpi"
    );
    Object?.entries(updateRadioChecked)
      ?.filter((el, i) => el[0]?.split("_")[0] === "kpi")
      ?.forEach((e, i) => {
        combineRadioCheckedArray?.push(
          Object.entries({
            [`kpi_card_${i + 1}`]: { data: { ...e[1]?.data } },
          })[0]
        );
      });

    let finalRadioCheckedArray = {};

    combineRadioCheckedArray?.forEach((el) => {
      finalRadioCheckedArray = {
        ...finalRadioCheckedArray,
        [el[0]]: { data: { ...el[1]?.data } },
      };
    });
    let combineRadioArray = Object?.entries(updateRadioArray)?.filter(
      (el) => el[0]?.split("_")[0] !== "kpi"
    );
    Object?.entries(updateRadioArray)
      ?.filter((el, i) => el[0]?.split("_")[0] === "kpi")
      ?.forEach((e, i) => {
        combineRadioArray?.push(
          Object.entries({
            [`kpi_card_${i + 1}`]: { data: [...e[1]?.data] },
          })[0]
        );
      });

    let finalRadioArray = {};
    combineRadioArray?.forEach((el) => {
      finalRadioArray = {
        ...finalRadioArray,
        [el[0]]: { data: [...el[1]?.data] },
      };
    });
    if (filterData?.length === 0 && Array.isArray(filterData)) {
      filterData?.push({
        card_id: uuid(),
        card_name: axisPanelAtt?.card_settings?.length + 1,
        card_value: null,
        x_axis: null,
        y_series: null,
        response: lastResponseIfBenchMarkCard
          ? lastResponseIfBenchMarkCard
          : null,
      });
    }
    let graphConfig = {
      ...axisPanelAtt,
      [`card_settings`]: [...filterData],
      [`edit_fields`]: {
        ...axisPanelAtt[`edit_fields`],
        boolValue: false,
        series: `kpi_card_${filterData?.length}`,
      },
      [`card_position`]: index === 1 ? "Top" : axisPanelAtt?.card_position,
    };
    if (finalRadioArray[`kpi_card_1`] && finalRadioCheckedArray[`kpi_card_1`]) {
      dispatch(setradioArray(finalRadioArray));
      dispatch(setradioChecked(finalRadioCheckedArray));
    } else {
      dispatch(
        setradioArray({ ...finalRadioArray, [`kpi_card_1`]: { data: [] } })
      );
      dispatch(
        setradioChecked({
          ...finalRadioCheckedArray,
          [`kpi_card_1`]: { data: {} },
        })
      );
    }

    dispatch(setY_attribute(graphConfig));
    setCardCount(0);
  };

  const handleCardName = (e, id) => {
    const updatedcard = axisPanelAtt?.card_settings?.map((d) => {
      if (d.card_id === id) {
        return { ...d, card_value: e.target.value };
      } else {
        return { ...d };
      }
    });

    dispatch(
      setY_attribute({
        ...axisPanelAtt,
        [`card_settings`]: [...updatedcard],
      })
    );
  };

  const handleBackgroundColor = (e) => {
    setBackgroundColor(e.target.value);
  };

  const handleFontColor = (e) => {
    setFontColor(e.target.value);
  };

  const handleCardPosition = (name) => {
    dispatch(setWidgetCardPosition(name, axisPanelAtt));
  };
  const handleCardLimit = (limit) => {
    let graphConfig = { ...axisPanelAtt };
    if (
      Array.isArray(axisPanelAtt?.card_settings) &&
      axisPanelAtt?.card_settings?.length
    ) {
      const filteredCard = axisPanelAtt?.card_settings?.map((item) => {
        item.x_axis.x_limit = parseInt(limit);
        return item;
      });
      graphConfig = {
        ...axisPanelAtt,
        [`card_settings`]: [...filteredCard],
      };
      // console.log("graphConfig : ",graphConfig);
      dispatch(setY_attribute(graphConfig));
    }
    dispatch(setWidgetCardLimit(limit, graphConfig));
  };

  const deleteAxisAttribute = (card_id, axis) => {
    // Clear active field if we're deleting the currently active field
    if (
      activeCardField?.cardId === card_id &&
      activeCardField?.fieldType === axis
    ) {
      setActiveCardField(null);
    }

    let cardSettings = axisPanelAtt?.card_settings?.map((e) => {
      if (e.card_id === card_id) {
        if (axis === "x_axis") {
          // When deleting x_axis, only set x_axis to null and clear response
          return {
            ...e,
            ["response"]: [],
            ["x_axis"]: null,
            // Keep y_series as is
          };
        } else if (axis === "y_series") {
          // When deleting y_series, only set y_series to null
          return {
            ...e,
            ["x_axis"]: null,

            ["y_series"]: null,
            // Keep x_axis and response as is
          };
        }
      }
      return e;
    });

    let graphConfig = {
      ...axisPanelAtt,
      [`card_settings`]: cardSettings,
    };
    dispatch(setY_attribute(graphConfig));
  };

  // Handle card field click to update attribute list
  const handleCardFieldClick = (cardId, fieldType, retryCount = 0) => {
    // Set active field
    setActiveCardField({ cardId, fieldType });

    // If clicking the same field that's already active, just maintain the state
    if (
      activeCardField?.cardId === cardId &&
      activeCardField?.fieldType === fieldType
    ) {
      // Ensure the attribute list stays open
      dispatch(
        setX_attribute({
          ...axisPanelAtt,
          // chart_attributes_field_config: {
          //   ...chartAttributesFieldConfig,
          //   selected_field: fieldType,
          //   open_chart_setting_flag: true,
          // },
          selected_card_id: cardId,
        })
      );

      dispatch(
        setChartAttributesFieldConfig({
          ...chartAttributesFieldConfigRef.current,
          selected_field: fieldType,
          open_chart_setting_flag: true,
        })
      );
      return;
    }

    // Use the stored original field configuration (captured before card settings)
    // Fall back to current config from ref if original not available
    const existingFieldConfig =
      originalFieldConfigRef.current ||
      chartAttributesFieldConfigRef.current?.data;

    // If no field config available yet, try again after a delay (max 3 retries)
    if (
      (!existingFieldConfig || existingFieldConfig.length === 0) &&
      retryCount < 3
    ) {
      // Silently retry
      setTimeout(() => {
        handleCardFieldClick(cardId, fieldType, retryCount + 1);
      }, 500);
      return;
    }

    let fieldConfigToUse = null;

    // Try to find the existing x_axis or y_series configuration
    if (existingFieldConfig && Array.isArray(existingFieldConfig)) {
      // Field configs available

      // For x_axis (Group by), look for x_axis field config
      if (fieldType === "x_axis") {
        fieldConfigToUse = existingFieldConfig.find(
          (field) => field.payload_key_name === "x_axis"
        );
      }
      // For y_series (Value), look for y_series field config
      else if (fieldType === "y_series") {
        fieldConfigToUse = existingFieldConfig.find(
          (field) => field.payload_key_name === "y_series"
        );
        // Found y_series config
      }
    }

    // If we found the field config, use it; otherwise create a fallback
    if (fieldConfigToUse) {
      // Check if attributes exist, if not warn but don't use x_axis as fallback
      // Check if attributes exist

      // Use the existing field configs we already retrieved
      const allFieldConfigs = existingFieldConfig || [];

      const fieldData = {
        data: allFieldConfigs, // Keep all field configurations
        selected_field: fieldType,
        open_chart_setting_flag: true, // Enable the flag as requested
      };

      // Update Redux state to trigger CollapsibleAttributeList update
      dispatch(
        setX_attribute({
          ...axisPanelAtt,
          // chart_attributes_field_config: fieldData,
          selected_card_id: cardId,
        })
      );
      dispatch(setChartAttributesFieldConfig(fieldData));
    } else {
      // Fallback if no existing config found
      // No existing field configuration found, create fallback

      // Use the existing field configs we already retrieved
      const allFieldConfigs = existingFieldConfig || [];

      // Create a basic field data structure
      const fieldData = {
        data: [
          ...allFieldConfigs,
          {
            key: fieldType,
            field_label: fieldType === "x_axis" ? "Group by" : "Value",
            payload_key_name: fieldType,
            required: fieldType === "y_series",
            multiple_allowed: false,
            attribute_type: fieldType === "y_series" ? "int" : "varchar",
            attributes: {}, // Empty attributes to prevent errors
          },
        ],
        selected_field: fieldType,
        open_chart_setting_flag: true,
      };

      dispatch(
        setX_attribute({
          ...axisPanelAtt,
          // chart_attributes_field_config: fieldData,
          selected_card_id: cardId,
        })
      );
      dispatch(setChartAttributesFieldConfig(fieldData));
    }
  };
  const onChange = (key) => {
    if (key === "2" || key === "filters") {
      setfilterSearch("");
      dispatch(setFilterActiveKey([]));
    }
  };

  const openEditFields = (
    series,
    attName,
    id,
    x_axis,
    trace_name,
    aggregation,
    sort_order,
    x_limit,
    e,
    card_data
  ) => {
    dispatch(setFilterActiveKey([]));
    setSearchTerm(null);
    setIsModalVisible(true);
    // setEditPanelPosition(e?.clientY);
    let data = {
      boolValue: true,
      series: series,
      attName: attName,
      card_id: id,
      x_axis: x_axis,
      values_trace_name: trace_name,
      values_aggregation: aggregation,
      group_by_sort_order: sort_order,
      group_by_x_limit: x_limit,
      card_data: card_data,
      info_text: card_data?.y_series?.info_text,
    };
    dispatch(setChartEditField(data, axisPanelAtt));
  };
  const callChartAPI = (graphConfig) => {
    dispatch(setOptionHighChart({}));
    let y_series_array = [];
    y_series_array = Object.keys(graphConfig?.y_axis).map(
      (key) => graphConfig?.y_axis[key]
    );
    y_series_array = y_series_array?.filter((el) => el?.attribute);
    if (
      widgetGraphConfig?.chart_type === "bubble" ||
      widgetGraphConfig?.chart_type === "heatmap" ||
      widgetGraphConfig?.chart_type === "sunburst" ||
      widgetGraphConfig?.chart_type === "wordcloud" ||
      widgetGraphConfig?.chart_type === "donut" ||
      widgetGraphConfig?.chart_type === "pie"
    ) {
      y_series_array =
        y_series_array?.length > 1 ? [y_series_array[0]] : y_series_array;
    }

    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };
    let card_settings_data = [];
    graphConfig?.card_settings?.map((d) => {
      if (
        (d?.x_axis?.attribute || (!d?.x_axis?.attribute && d?.y_series)) &&
        d?.y_series?.attribute
      ) {
        card_settings_data = [
          ...card_settings_data,
          {
            x_axis:
              d?.x_axis == null
                ? null
                : Object.keys(d?.x_axis).length == 0
                ? null
                : d?.x_axis,
            y_series: d?.y_series?.attribute ? d?.y_series : null,
          },
        ];
      }
    });

    const d = new Date();
    let utcOffset = d.getTimezoneOffset();
    let card_settings_index =
      card_settings_data && card_settings_data?.length
        ? card_settings_data?.length - 1
        : 0;
    if (card_settings_data && card_settings_data?.length) {
      if (card_settings_data && Array.isArray(card_settings_data)) {
        for (let i = card_settings_data?.length - 1; i >= 0; i--) {
          let card = card_settings_data?.[i];
          if (card?.x_axis?.atrribute || card?.y_series) {
            card_settings_index = i;
            break;
          }
        }
      }
    }
    let graphObject = {
      brand_list: [
        {
          brand_id: 600,
        },
      ],
      start_date: widgetGraphConfig?.duration?.from
        ? widgetGraphConfig?.duration?.from
        : defaultDuration?.from,
      end_date: widgetGraphConfig?.duration?.to
        ? widgetGraphConfig?.duration?.to
        : defaultDuration?.to,
      brands: widgetGraphConfig?.brands
        ? widgetGraphConfig?.brands
        : brandlogicalgroup?.length > 0
        ? brandlogicalgroup
        : brands,
      isBrandModified: widgetGraphConfig?.brands ? true : false,

      filters:
        widgetGraphConfig?.filters?.length > 0
          ? widgetGraphConfig?.filters
          : [],
      x_axis: widgetGraphConfig?.x_axis && widgetGraphConfig?.x_axis,
      // Break down data
      y_axes:
        widgetGraphConfig?.breakdown_by?.length > 0
          ? widgetGraphConfig?.breakdown_by
          : null,
      // y axis data
      y_series: y_series_array && y_series_array,
      widget_name: "abc",
      chart: {
        chart_type:
          widgetGraphConfig?.chart_type === "donut"
            ? "pie"
            : widgetGraphConfig?.chart_type,
        rich_fields_content: graphConfig?.rich_fields_content,
        chart_settings: {
          ...graphConfig?.chart_settings,
          //duration_comparison: true,
          // duration_comparison: false, // This is used for only KPI
          // show_previous_duration_comparison: false, // This is used for charts
          // show_previous_duration_data: false, // This is used for charts
          // show_data_labels: true,
          // is_stacked: true,
          // show_count_cards: true,
          // card_percent: true,
          // chart_percent: false,
          // gradient_color: false,
          show_data_labels: graphConfig?.chart_settings?.global_data_label,
          show_details_on_card:
            graphConfig?.chart_settings?.show_details_on_card,
          show_as_median: graphConfig?.chart_settings?.show_as_median,
          show_3d: graphConfig?.chart_settings?.show_3d,
          settings_3d: graphConfig?.chart_settings?.settings_3d,
          show_label_names: graphConfig?.chart_settings?.show_label_names,
          show_count_cards: graphConfig?.chart_settings?.data_count_card,
          chart_property: {
            chart_name: "Line chart",
            legend_position: "top",
            y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
          },
          y_axes_settings: widgetGraphConfig?.y_axis_settings,
          cards_settings: card_settings_data ? card_settings_data : null,
          chart_styles: graphConfig?.chart_settings?.chart_styles || null,
          cluster_chart_type: graphConfig?.chart_settings?.cluster_chart_type,
          cluster_style: graphConfig?.chart_settings?.cluster_style,
        },
      },
      card_settings_index: card_settings_index,
      widgetGraphConfig: graphConfig,
      order_by:
        widgetGraphConfig?.chart_type === "post-card" ||
        widgetGraphConfig?.chart_type === "author-card" ||
        widgetGraphConfig?.chart_type === "prolific-user"
          ? widgetGraphConfig?.order_by
          : null,
      utcOffset: utcOffset,
      edit: widgetGraphConfig?.edit,
      tags: widgetGraphConfig?.tags ? widgetGraphConfig?.tags : [],
    };
    // Check and update chart settings based on benchmark line case
    let updatedGraphObject = updateChartSettingsInGraphObjectBasedOnSelection({
      widgetGraphConfig: widgetGraphConfig,
      brandlogicalgroup: brandlogicalgroup,
      brands: brands,
      graphObject: graphObject,
    });
    if (updatedGraphObject) {
      graphObject = updatedGraphObject;
    }
    if (widgetGraphConfig?.chart_type === "network-graph-v2") {
      graphObject.isNetworkChartV2 =
        graphObject?.chart?.chart_type === "network-graph-v2" ? true : false;
    }
    if (
      graphConfig?.card_settings[graphConfig?.card_settings?.length - 1]
        ?.x_axis ||
      graphConfig?.card_settings[graphConfig?.card_settings?.length - 1]
        ?.y_series
    ) {
      authParams &&
        graphConfig?.card_settings?.length - 1 >= 0 &&
        dispatch(setWidgetMakerGraphData(authParams, graphObject));
    }
  };
  const changeSeriesAggregation = (value, i) => {
    dispatch(
      setCardSeriesAggregation(value === "None" ? null : value, axisPanelAtt, i)
    );
    let graphConfig = {
      ...axisPanelAtt,
    };
    graphConfig.card_settings[i].series_aggregation =
      value === "null" ? null : value;
    callChartAPI(graphConfig);
  };
  const handleBenchmarkLine = (e, i) => {
    dispatch(setCardBenchmarkLine(e.target.checked, axisPanelAtt, i));
    let graphConfig = {
      ...axisPanelAtt,
    };
    graphConfig.card_settings[i].benchmark_line = e.target.checked;
    callChartAPI(graphConfig);
  };
  const grid = 8;
  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: `${grid}px`,
    // margin: isDragging ? `0 0 ${grid}px 0` : "",
    borderRadius: "0.8rem",
    // change background colour if dragging
    background: isDragging
      ? authParams?.theme_type === "1"
        ? "#FFFFFF"
        : "rgb(103 139 255 / 50%)"
      : "",
    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    boxShadow: isDraggingOver
      ? `0 0.2rem 1.9rem ${
          authParams?.theme_type === "1" ? "#FFFFFF" : "rgba(0, 0, 0, 0.2)"
        } `
      : null,
    borderRadius: "0.8rem",
    background: isDraggingOver
      ? authParams?.theme_type === "1"
        ? "#FFFFFF"
        : "rgb(103 139 255 / 10%)"
      : "",
  });
  return (
    <>
      {!["grid", "rich-text"]?.includes(axisPanelAtt?.chart_type) &&
        axisPanelAtt?.card_settings[axisPanelAtt?.card_settings?.length - 1]
          ?.response?.length > 0 && (
          <>
            <div className="floating-label-group header-brands mb-15 mt-3">
              <Select
                style={{
                  width: "100%",
                }}
                label="Card Position"
                placeholder="Card Position"
                defaultValue="Top"
                value={widgetGraphConfig?.card_position}
                onChange={handleCardPosition}
                dropdownClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                <Option value="Top">Top</Option>
                <Option value="Bottom">Bottom</Option>
                <Option value="Left">Left</Option>
                <Option value="Right">Right</Option>
              </Select>
              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-0.8rem" }}
              >
                Cards Position
              </label>
            </div>
            {/* <div className="text_regular font-weight600">Showing</div>
            <div className={`w-100 mb-15`}>
              <div className="floating-label-group d-flex align-items-center">
                <Select
                  defaultValue="top"
                  className="w-100"
                  dropdownClassName={
                    authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                  }
                >
                  <Option key={0} value="top">
                    Top
                  </Option>
                </Select>
                <Select
                  style={{
                    width: "100%",
                  }}
                  label="Card Limit"
                  placeholder="Card Limit"
                  defaultValue={5}
                  value={widgetGraphConfig?.card_limit}
                  onChange={handleCardLimit}
                  dropdownClassName={
                    authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                  }
                >
                  <Option value={5}>5</Option>
                  <Option value={10}>10</Option>
                  <Option value={15}>15</Option>
                </Select>
              </div>
            </div> */}
          </>
        )}
      {axisPanelAtt &&
      axisPanelAtt?.card_settings &&
      Array.isArray(axisPanelAtt?.card_settings) ? (
        <>
          <Droppable
            droppableId="CardSetting_Container"
            type="CardSettingColumn"
            direction="vertical"
            // ignoreContainerClipping={Boolean(containerHeight)}
            // isCombineEnabled={isCombineEnabled}
          >
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className="CardSetting_wrraper--container"
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {axisPanelAtt &&
                  axisPanelAtt?.card_settings?.map((data, i) => {
                    return (
                      <Draggable
                        draggableId={`CardSetting_wrraper#${data?.card_id}`}
                        index={i}
                        key={`CardSetting_wrraper#${data?.card_id}`}
                        type="CardSettingColumn"
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            <div className="CardSetting_wrraper">
                              <div className="d-flex justify-content-between">
                                <div className="text_regular font-weight600">
                                  <span>
                                    <img
                                      src={Drag_Icon}
                                      alt="Drag"
                                      className="accordionArrow mr-1 cursor-drop"
                                      style={{
                                        transform: `rotate("180deg")`,
                                      }}
                                    />
                                  </span>
                                  Group by
                                </div>
                                {data?.x_axis || data?.y_series ? (
                                  <div
                                    onClick={() => removeNewCard(data, i + 1)}
                                    className="blue-text cursor-pointer"
                                  >
                                    Remove
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <Droppable
                                droppableId={`card_settings#x_axis#${data?.card_id}`}
                                key={`card_settings#x_axis#${data?.card_id}`}
                                className="mx-2"
                                type="DEFAULT" // Ensuring the type is unique for this droppable area
                              >
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className="border-radius-4 d-flex justify-content-between align-items-center mb-2"
                                    // onClick={() =>
                                    //   handleCardFieldClick(
                                    //     data?.card_id,
                                    //     "x_axis"
                                    //   )
                                    // }
                                    style={{
                                      height: "4rem",
                                      cursor: "pointer",
                                      border: `0.1rem ${
                                        !data?.x_axis?.attribute
                                          ? "dashed"
                                          : "solid"
                                      } ${
                                        activeCardField?.cardId ===
                                          data?.card_id &&
                                        activeCardField?.fieldType === "x_axis"
                                          ? "#1890ff" // Highlight active field
                                          : axisPanelAtt.dragDataType.varchar ||
                                            axisPanelAtt.dragDataType.datetime
                                          ? "#DDDDDD"
                                          : !data?.x_axis?.attribute
                                          ? "#9CB4FF"
                                          : "#d9e5ed"
                                      }`,
                                      backgroundColor:
                                        activeCardField?.cardId ===
                                          data?.card_id &&
                                        activeCardField?.fieldType === "x_axis"
                                          ? "#e6f7ff" // Light blue background for active field
                                          : authParams?.theme_type === "1" ||
                                            darkTheme
                                          ? ""
                                          : !data?.x_axis?.attribute
                                          ? "#F2F7FF"
                                          : "",
                                      boxShadow:
                                        activeCardField?.cardId ===
                                          data?.card_id &&
                                        activeCardField?.fieldType === "x_axis"
                                          ? `0 0 0 2px rgba(24, 144, 255, 0.2)` // Active field shadow
                                          : axisPanelAtt.dragDataType.varchar &&
                                            `0 0.2rem 0.5rem ${
                                              authParams?.theme_type === "1"
                                                ? "#fff"
                                                : "rgb(103 139 255 / 50%)"
                                            }`,
                                    }}
                                  >
                                    {!data?.x_axis?.attribute ? (
                                      <span
                                        onClick={() =>
                                          handleCardFieldClick(
                                            data?.card_id,
                                            "x_axis"
                                          )
                                        }
                                        className="cursor-pointer p-2 w-100 text-center text_regular no--wrap"
                                      >
                                        Click to select attribute
                                      </span>
                                    ) : (
                                      <span
                                        onClick={() =>
                                          handleCardFieldClick(
                                            data?.card_id,
                                            "x_axis"
                                          )
                                        }
                                        className=" text_regular p-2 text-ellipsis"
                                        // onClick={(e) =>
                                        //   openEditFields(
                                        //     "group_by",
                                        //     data?.x_axis?.attribute,
                                        //     data.card_id,
                                        //     null,
                                        //     data?.x_axis?.trace_name,
                                        //     null,
                                        //     data?.x_axis?.sort_order,
                                        //     data?.x_axis?.x_limit,
                                        //     e,
                                        //     data
                                        //   )
                                        // }
                                      >
                                        <Tooltip
                                          title={
                                            data?.x_axis?.trace_name ||
                                            All_WM_attributes[
                                              data?.x_axis?.attribute
                                            ] ||
                                            data?.x_axis?.attribute
                                          }
                                        >
                                          {(() => {
                                            const title =
                                              data?.x_axis?.trace_name ||
                                              All_WM_attributes[
                                                data?.x_axis?.attribute
                                              ] ||
                                              data?.x_axis?.attribute ||
                                              "Unknown";
                                            return title?.length > 17
                                              ? title?.substr(0, 17) + " ..."
                                              : title;
                                          })()}
                                        </Tooltip>
                                      </span>
                                    )}
                                    {data?.x_axis?.attribute && (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          gap: "1rem",
                                        }}
                                      >
                                        {" "}
                                        <Tooltip
                                          title={"Attribute Configuration"}
                                        >
                                          <img
                                            src={
                                              authParams?.theme_type === "1"
                                                ? SettingsLogo
                                                : SettingLogoHover
                                            }
                                            onClick={(e) =>
                                              openEditFields(
                                                "group_by",
                                                data?.x_axis?.attribute,
                                                data.card_id,
                                                null,
                                                data?.x_axis?.trace_name,
                                                null,
                                                data?.x_axis?.sort_order,
                                                data?.x_axis?.x_limit,
                                                e,
                                                data
                                              )
                                            }
                                            alt="arrow"
                                            className="accordionArrow ml-15 cursor-pointer"
                                            style={{
                                              transform: `rotate("180deg")`,
                                            }}
                                          />
                                        </Tooltip>
                                        <CloseIcon
                                          className="mr-2"
                                          onClick={() =>
                                            deleteAxisAttribute(
                                              data.card_id,
                                              "x_axis"
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                    {/* {provided.placeholder} */}
                                  </div>
                                )}
                              </Droppable>
                              <div className="text_regular font-weight600">
                                Value <span className="error">*</span>
                              </div>
                              <Droppable
                                droppableId={`card_settings#y_series#${data?.card_id}`}
                                key={`card_settings#y_series#${data?.card_id}`}
                                type="DEFAULT" // Ensuring the type is unique for this droppable area
                              >
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className="border-radius-4 d-flex justify-content-between align-items-center"
                                    // onClick={() =>
                                    //   handleCardFieldClick(
                                    //     data?.card_id,
                                    //     "y_series"
                                    //   )
                                    // }
                                    style={{
                                      height: "4rem",
                                      cursor: "pointer",
                                      border: `0.1rem ${
                                        !data?.y_series?.attribute
                                          ? "dashed"
                                          : "solid"
                                      } ${
                                        activeCardField?.cardId ===
                                          data?.card_id &&
                                        activeCardField?.fieldType ===
                                          "y_series"
                                          ? "#1890ff" // Highlight active field
                                          : axisPanelAtt.dragDataType.varchar ||
                                            axisPanelAtt.dragDataType.datetime
                                          ? "#DDDDDD"
                                          : !data?.y_series?.attribute
                                          ? "#9CB4FF"
                                          : "#d9e5ed"
                                      }`,
                                      backgroundColor:
                                        activeCardField?.cardId ===
                                          data?.card_id &&
                                        activeCardField?.fieldType ===
                                          "y_series"
                                          ? "#e6f7ff" // Light blue background for active field
                                          : authParams?.theme_type === "1"
                                          ? ""
                                          : !data?.y_series?.attribute
                                          ? "#F2F7FF"
                                          : "",
                                      boxShadow:
                                        activeCardField?.cardId ===
                                          data?.card_id &&
                                        activeCardField?.fieldType ===
                                          "y_series"
                                          ? `0 0 0 2px rgba(24, 144, 255, 0.2)` // Active field shadow
                                          : axisPanelAtt.dragDataType.int &&
                                            axisPanelAtt.dragDataType
                                              .attribute !== "nss" &&
                                            axisPanelAtt.dragDataType
                                              .attribute !== "srs" &&
                                            axisPanelAtt.dragDataType
                                              .attribute !== "flr" &&
                                            `0 0.2rem 0.5rem ${
                                              authParams?.theme_type === "1"
                                                ? "#fff"
                                                : "rgb(103 139 255 / 50%)"
                                            }`,
                                    }}
                                  >
                                    {!data?.y_series?.attribute ? (
                                      <span
                                        onClick={() =>
                                          handleCardFieldClick(
                                            data?.card_id,
                                            "y_series"
                                          )
                                        }
                                        className="cursor-pointer p-2 w-100 text-center text_regular no--wrap"
                                      >
                                        Click to select attribute
                                      </span>
                                    ) : (
                                      <span
                                        onClick={() =>
                                          handleCardFieldClick(
                                            data?.card_id,
                                            "y_series"
                                          )
                                        }
                                        className="text_regular p-2 text-ellipsis"
                                        // onClick={(e) =>
                                        //   openEditFields(
                                        //     `kpi_card_${data?.card_name}`,
                                        //     data?.y_series?.attribute,
                                        //     data.card_id,
                                        //     data?.x_axis?.attribute,
                                        //     data?.y_series?.trace_name,
                                        //     data?.y_series?.aggregation,
                                        //     null,
                                        //     null,
                                        //     e,
                                        //     data
                                        //   )
                                        // }
                                      >
                                        <Tooltip
                                          title={
                                            data?.y_series?.trace_name ||
                                            All_WM_attributes[
                                              data?.y_series?.attribute
                                            ] ||
                                            data?.y_series?.attribute
                                          }
                                        >
                                          {(() => {
                                            const title =
                                              data?.y_series?.trace_name ||
                                              All_WM_attributes[
                                                data?.y_series?.attribute
                                              ] ||
                                              data?.y_series?.attribute ||
                                              "Unknown";
                                            return title?.length > 13
                                              ? title?.substr(0, 13) + " ..."
                                              : title;
                                          })()}
                                        </Tooltip>
                                        {axisPanelAtt?.card_settings[i]
                                          ?.y_series?.filters?.length ? (
                                          <Tooltip
                                            placement="leftTop"
                                            overlayStyle={{
                                              width: axisPanelAtt
                                                ?.card_settings[i]?.y_series
                                                ?.filters?.length
                                                ? "22rem"
                                                : "15rem",
                                            }}
                                            color="#3B5175"
                                            title={
                                              <>
                                                <div
                                                  className="custom_scroll"
                                                  style={{
                                                    maxWidth: "27rem",
                                                    maxHeight: "23rem",
                                                    overflow: "auto",
                                                    scrollBehavior: "smooth",
                                                  }}
                                                >
                                                  {axisPanelAtt?.card_settings[
                                                    i
                                                  ]?.y_series?.filters?.length
                                                    ? axisPanelAtt?.card_settings[
                                                        i
                                                      ]?.y_series?.filters?.map(
                                                        (el) => {
                                                          return (
                                                            el?.attribute !==
                                                              "brandid" &&
                                                            el?.attribute !==
                                                              "createddate" && (
                                                              <div className="mb-2">
                                                                <p className="mb-0 text-white">
                                                                  <strong>
                                                                    {el?.attribute ===
                                                                    "brandid"
                                                                      ? "Brands"
                                                                      : All_WM_attributes &&
                                                                        All_WM_attributes[
                                                                          el
                                                                            ?.attribute
                                                                        ]
                                                                      ? All_WM_attributes[
                                                                          el
                                                                            ?.attribute
                                                                        ]
                                                                      : el?.attribute?.toLowerCase() ===
                                                                        "categoryid"
                                                                      ? "Category"
                                                                      : el?.attribute?.toLowerCase() ===
                                                                        "subcategoryid_aug"
                                                                      ? "Sub Category"
                                                                      : el?.attribute?.toLowerCase() ===
                                                                        "subsubcategoryid"
                                                                      ? "Sub Sub Category"
                                                                      : el?.attribute?.replace(
                                                                          "Type",
                                                                          ""
                                                                        )}
                                                                  </strong>
                                                                </p>
                                                                {el?.type ===
                                                                  "int" &&
                                                                  !Array.isArray(
                                                                    el?.columns
                                                                  ) && (
                                                                    <span className="font-weight-light text-white">
                                                                      {el
                                                                        ?.columns
                                                                        ?.from +
                                                                        " - " +
                                                                        el
                                                                          ?.columns
                                                                          ?.to}
                                                                    </span>
                                                                  )}
                                                                {el?.attribute ===
                                                                "createddate" ? (
                                                                  <span
                                                                    className="font-weight-light"
                                                                    style={{
                                                                      color:
                                                                        "#fff",
                                                                    }}
                                                                  >
                                                                    {`${el?.columns?.from} - ${el?.columns?.to}`}
                                                                  </span>
                                                                ) : (
                                                                  Array.isArray(
                                                                    el?.columns
                                                                  ) &&
                                                                  el?.columns?.map(
                                                                    (
                                                                      e,
                                                                      index
                                                                    ) => {
                                                                      return (
                                                                        <span
                                                                          className="font-weight-light"
                                                                          style={{
                                                                            color:
                                                                              e?.type ===
                                                                              "include"
                                                                                ? "#5ed66d"
                                                                                : e?.type ===
                                                                                  "exclude"
                                                                                ? "#fb7665"
                                                                                : "#fff",
                                                                          }}
                                                                        >
                                                                          {(index
                                                                            ? ", "
                                                                            : "") +
                                                                            (e?.display_name
                                                                              ? e?.display_name
                                                                              : e?.name ===
                                                                                null
                                                                              ? "Any"
                                                                              : e?.name ===
                                                                                0
                                                                              ? "No"
                                                                              : e?.name ===
                                                                                1
                                                                              ? "Yes"
                                                                              : e?.name)}
                                                                        </span>
                                                                      );
                                                                    }
                                                                  )
                                                                )}
                                                              </div>
                                                            )
                                                          );
                                                        }
                                                      )
                                                    : ` `}
                                                </div>
                                              </>
                                            }
                                          >
                                            <Space size="small">
                                              <Badge
                                                style={{
                                                  backgroundColor: "#185edf",
                                                  fontSize: "1rem",
                                                  marginLeft: "1rem",
                                                }}
                                                title=""
                                                size="small"
                                                count={
                                                  axisPanelAtt?.card_settings[i]
                                                    ?.y_series?.filters?.length
                                                    ? axisPanelAtt
                                                        ?.card_settings[i]
                                                        ?.y_series?.filters
                                                        ?.length
                                                    : 0
                                                }
                                              ></Badge>
                                            </Space>
                                          </Tooltip>
                                        ) : (
                                          ""
                                        )}
                                      </span>
                                    )}
                                    {data?.y_series?.attribute && (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          gap: "1rem",
                                        }}
                                      >
                                        <Tooltip
                                          title={"Attribute Configuration"}
                                        >
                                          {" "}
                                          <img
                                            src={
                                              authParams?.theme_type === "1"
                                                ? SettingsLogo
                                                : SettingLogoHover
                                            }
                                            onClick={(e) =>
                                              openEditFields(
                                                `kpi_card_${data?.card_name}`,
                                                data?.y_series?.attribute,
                                                data.card_id,
                                                data?.x_axis?.attribute,
                                                data?.y_series?.trace_name,
                                                data?.y_series?.aggregation,
                                                null,
                                                null,
                                                e,
                                                data
                                              )
                                            }
                                            alt="arrow"
                                            className="accordionArrow ml-15 cursor-pointer"
                                            style={{
                                              transform: `rotate("180deg")`,
                                            }}
                                          ></img>
                                        </Tooltip>

                                        <CloseIcon
                                          className="mr-2"
                                          onClick={() =>
                                            deleteAxisAttribute(
                                              data.card_id,
                                              "y_series"
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                    {/* {provided.placeholder} */}
                                  </div>
                                )}
                              </Droppable>
                              {/* <div className="text_regular font-weight600 mt-2">
                Series Aggregation
              </div>
              <div className="floating-label-group header-brands mt-2">
                <Select
                  defaultValue="None"
                  value={data?.series_aggregation}
                  onChange={(e) => changeSeriesAggregation(e, i)}
                  className="w-100"
                >
                  <>
                    <Option key={2} value="None">
                      None
                    </Option>
                    <Option key={2} value="min">
                      Min
                    </Option>
                    <Option key={3} value="max">
                      Max
                    </Option>
                    <Option key={4} value="avg">
                      Average
                    </Option>
                    <Option key={5} value="sum">
                      Sum
                    </Option>
                  </>
                </Select>
                <label
                  className="portlet-label floating-label bg__white font-size12"
                  style={{ top: "-0.8rem" }}
                >
                  Aggregation
                </label>
              </div>
              {(axisPanelAtt?.chart_type === "line" ||
                axisPanelAtt?.chart_type === "area" ||
                axisPanelAtt?.chart_type === "bar" ||
                axisPanelAtt?.chart_type === "combination") && (
                <Checkbox
                  value="Benchmark Line"
                  className="text_regular font-weight600 mt-2"
                  onChange={(e) => handleBenchmarkLine(e, i)}
                  checked={data?.benchmark_line}
                >
                  Benchmark Line
                </Checkbox>
              )} */}

                              {i !== axisPanelAtt?.card_settings?.length - 1 ? (
                                <div className="wm-card-settings-card-border"></div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </>
      ) : (
        ""
      )}

      {
        <>
          {(!addNewCards || isAddingNewCard) &&
          cardCount < 15 &&
          canAddNewCard ? (
            <div
              style={{ marginTop: "1rem", marginLeft: "0.8rem" }}
              onClick={() => addNewCard()}
              className={`cursor-pointer d-flex align-items-center blue-text ${
                chartLoader && "disable"
              }`}
            >
              <PlusOutlined size="small" /> &nbsp; Add new card
            </div>
          ) : (
            <Tooltip
              title={`${
                !canAddNewCard
                  ? "Please select a value attribute for the last card"
                  : addNewCards
                  ? "Please add attribute to the asterisk(*) marked field(s)"
                  : "KPI cards limit reached"
              }`}
            >
              <div style={{ marginTop: "1rem", marginLeft: "0.8rem" }}>
                <span className="disable d-flex align-items-center blue-text">
                  <PlusOutlined size="small" /> &nbsp; Add new card
                </span>
              </div>
            </Tooltip>
          )}
        </>
      }
      {/* {axisPanelAtt?.edit_fields?.boolValue && (
        <div
          className="position-fixed axisPanelAtt bg__white box-shadow border-radius-10"
          style={{
            top:
              windowHeight >= 270 && editPanelPosition > 0
                ? `${editPanelPosition - 20}px`
                : "15rem",
            left: isshowSideBar ? "32rem" : "53rem",
            width: "30rem",
            zIndex: "2",
          }}
        >
          <Tabs defaultActiveKey="1" onChange={onChange}>
            <Tabs.TabPane tab="Edit Field" key="1">
              <EditFieldPanel
                editName={editName}
                setEditName={setEditName}
                editAggregation={editAggregation}
                setAggregation={setAggregation}
                setEditPanel={axisPanelAtt?.edit_fields}
                editPanel={axisPanelAtt?.edit_fields}
                yData={axisPanelAtt?.y_axis}
                editseries={axisPanelAtt?.edit_fields?.series}
              />
            </Tabs.TabPane>
            {!(
              axisPanelAtt?.edit_fields?.series === "x_axis" ||
              axisPanelAtt?.edit_fields?.series === "breakdown"
            ) &&
              axisPanelAtt?.edit_fields?.series?.split("_")[0] === "kpi" && (
                <Tabs.TabPane tab="Filters" key="filters">
                  <div
                    style={{
                      maxHeight:
                        windowHeight >= 270 && editPanelPosition > 0
                          ? `calc(100vh - ${editPanelPosition + 90}px)`
                          : "calc(100vh - 32rem)",
                      overflow: "auto",
                    }}
                    className="custom_scroll1 mr-1"
                  >
                    <FilterDrawer
                      editName={editName}
                      editAggregation={editAggregation}
                      type={axisPanelAtt?.edit_fields?.series}
                      filterSearch={filterSearch}
                      setfilterSearch={setfilterSearch}
                      isFilterApplied={isFilterApplied}
                      setisFilterApplied={setisFilterApplied}
                      widgetMakerClearFilter={widgetMakerClearFilter}
                      setWidgetMakerClearFilter={setWidgetMakerClearFilter}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>

                  <div className="d-flex justify-content-between align-items-center mx-2 my-2">
                    <Button
                      className="btn_Clear"
                      onClick={() => {
                        setWidgetMakerClearFilter(true);
                      }}
                    >
                      Clear Filter
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => setisFilterApplied(true)}
                      className="ant-btn-primary_blue"
                    >
                      Apply
                    </Button>
                  </div>
                </Tabs.TabPane>
              )}
          </Tabs>
        </div>
      )} */}

      {/* New Modal Approach */}
      {isModalVisible ? (
        <EditFieldModal
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          editName={editName}
          setEditName={setEditName}
          editAggregation={editAggregation}
          setAggregation={setAggregation}
          filterSearch={filterSearch}
          setfilterSearch={setfilterSearch}
          isFilterApplied={isFilterApplied}
          setisFilterApplied={setisFilterApplied}
          widgetMakerClearFilter={widgetMakerClearFilter}
          setWidgetMakerClearFilter={setWidgetMakerClearFilter}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          callChartAPI={callChartAPI}
          onChange={onChange}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default CardSetting;
